/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { sha256 } from 'js-sha256';

/**
 * execute callback. Variable name intentionally short
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const p = <T = any>(innerFunction: (...args: any) => T) => innerFunction();

export const generateEventNameHash = (eventName: string): string => {
    // Only generate hash client side
    if (typeof window !== 'undefined') {
        return sha256(eventName);
    }
    return eventName;
};
